import { reactive, ref } from 'vue';

import { memoize } from '@/helpers/memoize/memoize';
import { useCountry } from '@/hooks/use-country/use-country';
import { getGrowthBookFeatureValue, GrowthBookFeatures } from '@/services/growth-book/growth-book';
import { dispatch } from '@/store/store-helper';

export function useSplitGeoPaymentPrioritization() {
  const variant = ref<GrowthBookFeatures['geo_payment_prioritization']>('def');
  const isInited = ref(false);

  async function init() {
    const country = useCountry();

    try {
      const profileFull = await memoize(dispatch)('actionMyProfileGetFull');
      await country.load();

      variant.value = (await getGrowthBookFeatureValue('geo_payment_prioritization', 'def', {
        regDateUnix: profileFull.timeCreated,
        countryAlpha3: country.country.value?.country.isoCodeAlpha3,
      })) as GrowthBookFeatures['geo_payment_prioritization'];
    } finally {
      isInited.value = true;
    }
  }

  return reactive({ variant, isInited, init });
}
